import { Component, Vue, Mixins } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { creditEdit } from '@/util/Form';
import { RedirectPaymentMethodEnum } from '@/generated/api';

@Component({
    components: AllComponents(),
})
export default class Payment extends Mixins(CommonView) {
    pnkzList: {name: string, path: string | null}[] = [];

    error: string = "";
    user: BASEAPI.User = BASEAPI.user();
    paymentMethod: RedirectPaymentMethodEnum = RedirectPaymentMethodEnum.CARD;

    public async created() {
        if (await this.isLoginRedirect(true)) return;
        
        this.pnkzList = [
            {name: "TOP", path: "/"},
            {name: "マイページ", path: "/mypage"},
            {name: "登録クレジットカード変更・確認", path: null}
        ];
    }

    public async pay() {
        if (!this.loginStatus) {
            this.error = "不正なリクエストです。";
            return;
        }
        const url = "/mypage/payment";//urlを飛ばす必要はなさそう
        let redirectRes = await BASEAPI.RedirectController.addRedirectUsingPOST({ url: url, paymentMethod: this.paymentMethod }).catch(AxiosErrorHandler);
        if (isAxiosError(redirectRes)) {
            this.error = "" + redirectRes.data;
            return;
        }
        try {
            let res = await creditEdit("/api/credit/callBack?id=" + redirectRes.data.id, "/mypage/payment", "", "");
        } catch (error) {
            this.error = "" + error;
            return;
        }

    }
}
